import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoVelocityS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.87164 1C5.1157 1 5.33445 1.15058 5.42159 1.37855L7.44034 6.6601C7.44979 6.68484 7.47352 6.70117 7.5 6.70117C7.52648 6.70117 7.55021 6.68484 7.55966 6.6601L9.57841 1.37855C9.66555 1.15058 9.8843 1 10.1284 1C10.5454 1 10.8303 1.42169 10.6745 1.80859L8.37914 7.51125C8.26028 7.80656 7.97389 8 7.65556 8L7.34444 8C7.02611 8 6.73972 7.80656 6.62086 7.51125L4.32547 1.80859C4.16974 1.42169 4.45457 1 4.87164 1Z"
        fill="#32B4FF"
      />
      <path
        d="M0.987751 13.6816L3.27003 9.91602H4.35555L4.35555 15.0941H3.36779L3.36779 11.3252L1.09563 15.0941H0L0 9.91602H0.987751L0.987751 13.6816Z"
        fill="#32B4FF"
      />
      <path
        d="M9.22014 12.0702V12.9433L6.41533 12.9433V12.0702L9.22014 12.0702ZM6.69851 9.91602L6.69851 15.0941H5.71075L5.71075 9.91602H6.69851ZM9.92471 9.91602V15.0941H8.94033V9.91602H9.92471Z"
        fill="#32B4FF"
      />
      <path
        d="M10.631 10.7858V9.91602H15V10.7858H13.311V15.0941H12.3267V10.7858H10.631Z"
        fill="#32B4FF"
      />
    </svg>
  )
}

export const IconGeoVelocity = createIcon({
  l: IconGeoVelocityS,
  m: IconGeoVelocityS,
  s: IconGeoVelocityS,
  xs: IconGeoVelocityS,
  name: 'IconGeoVelocity',
})
